import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../store/services/auth.service';
import { FirestoreService } from '../../shared/firestore/firestore.service';
import { IProject } from '../../shared/firestore/models/project';
import { IUser } from '../../shared/firestore/models/user';


@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.sass']
})
export class ProjectsComponent implements OnInit {
  user$: Observable<IUser>;
  projects$: Observable<IProject[]>;
  opened: boolean;
  selectedProject: IProject;
  selectedProjectId: string;

  constructor(
    private auth: AuthService,
    private firestore: FirestoreService,
  ) {
    this.opened = false;
  }

  ngOnInit() {
    const firestoreUser$ = this.auth.getUserProfile().map(profile =>
      this.firestore.findUser(profile.userId));
    this.user$ = firestoreUser$.switchMap(store => store.data$);
    this.projects$ = firestoreUser$.switchMap(store => store.projects$);
  }

  invite(project, projectId) {
    this.opened = !this.opened;
    this.selectedProject = project;
    this.selectedProjectId = projectId;
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/projects/projects.component.ts